import { PROJECT_KEYS } from '@/Shared/constants/keys/keys';
import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay';
import store from '@/Shared/store/index';

// Отправка причины принудительного разлогина на бэкенд для аналитики
const reportForcedLogout = (reason) => {
  try {
    const url = `${store.getters.getBackendUrl}/api/auth/report-logout/`;
    const body = JSON.stringify({ reason });
    fetch(url, {
      method: 'POST',
      body,
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      keepalive: true,
    });
  } catch {
    // Логирование не должно ломать основной флоу
  }
};

export { reportForcedLogout };

// Принудительный разлогин: чистим всё и редирект
export const forceLogout = async (reason) => {
  reportForcedLogout(reason);
  localStorage.removeItem('access_token');
  store.commit('clearAccessToken');
  store.commit('UserSystem/clearUserData');
  window.location.href = '/?session=expired';
};
const refreshAccessToken = async () => {
  try {
    const response = await fetch(`${store.getters.getBackendUrl}/api/token/refresh/`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      // 400/401 — токен невалиден, разлогиниваем. 5xx — серверная ошибка, не трогаем
      if (response.status === 400 || response.status === 401) {
        await forceLogout('refresh_failed');
      }
      return false;
    }

    const data = await response.json();
    if (data.access) {
      store.commit('setAccessToken', data.access);
    }
    return true;
  } catch (error) {
    // Сетевая ошибка — не логаутим, просто false
    console.error('[AUTH] Refresh network error:', error);
    return false;
  }
};

export const fetchWithAuth = async (url, options = {}) => {
  const accessToken = store.getters.getAccessToken;

  if (accessToken) {
    options.headers = {
      ...options.headers,
      'Authorization': `Bearer ${accessToken}`,
    };
  }

  try {
    let response = await fetch(url, options);

    if (response.status === 401 && accessToken) {
      const refreshed = await refreshAccessToken();
      if (refreshed) {
        options.headers['Authorization'] = `Bearer ${store.getters.getAccessToken}`;
        response = await fetch(url, options);
      }
    }

    return response;
  } catch (error) {
    callOverlay({ text: 'Сервер временно недоступен. Попробуйте позже.', color: 'red', icon: 'wifi' });
    throw new Error(`Сервер недоступен: ${error}`);
  }
};

// Токен авторизации
const AUTH_TOKEN = PROJECT_KEYS.AUTH_TOKEN;

export const fetchAIAgentDataWithAuth = async (url, options = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(AUTH_TOKEN && { 'Authorization': `Token ${AUTH_TOKEN}` }),
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
    }

    return response;
  } catch (error) {
    console.error('Error in fetchAIAgentDataWithAuth:', error);
    throw error;
  }
};
